export default "__VITE_ASSET__ZCr8VUco__"